// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/compat/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/compat/analytics";

var firebaseConfig = {
	apiKey: process.env.REACT_APP_API_KEY,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_PROJECT_ID,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
	storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MESSAGIN_ID,
	appId: process.env.REACT_APP_APP_ID,
	measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);

// Disable analytics in development or when offline
if (process.env.NODE_ENV === 'production' && navigator.onLine) {
	try {
		firebase.analytics();
	} catch (error) {
		console.warn('Analytics initialization failed:', error);
	}
}

export const firebaseInstance = firebase;
export const authService = firebase.auth();
export const dbService = firebase.firestore();
export const storageService = firebase.storage();
